<template>
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span>添加门店</span>
		</div>
		<div style="background-color: white;display: flex;align-content: space-between;flex-wrap: wrap;">
			<el-form ref="form" size="mini" :model="store" :rules="rules" label-position="left" label-width="auto"
				:inline="true" style="width: 100%;">
				<div style="display: grid;grid-template-columns: 25% 25% 25% 25%">
					<el-form-item label="门店名称" prop="store_name">
						<el-input v-model="store.store_name"></el-input>
					</el-form-item>
					<el-form-item label="负责人" prop="store_man">
						<el-input v-model="store.store_man"></el-input>
					</el-form-item>
					<el-form-item label="负责人电话" prop="store_tel">
						<el-input v-model="store.store_tel"></el-input>
					</el-form-item>
					<el-form-item label="紧急联系电话" prop="store_tel2">
						<el-input v-model="store.store_tel2"></el-input>
					</el-form-item>
					<el-form-item label="门店地址" prop="store_address">
						<el-input v-model="store.store_address"></el-input>
					</el-form-item>
					<el-form-item label="管理员密码" prop="store_password">
						<el-input v-model="store.store_password" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="store_password2">
						<el-input v-model="store.store_password2" type="password"></el-input>
					</el-form-item>
					<el-form-item label="提现支付宝账号" prop="alipay_login_user">
						<el-input v-model="store.alipay_login_user"></el-input>
					</el-form-item>
				</div>

				<el-divider> 相关图片 </i></el-divider>
				<el-form-item label="营业执照" prop="store_license_img">
					<el-upload class="avatar-uploader" :action="host+'/store/upload'" :on-success="onSuccesslicense_img"
						:limit="1" :data="{dir:'store'}" :show-file-list="false">
						<img v-if="store.store_license_img" :src="host+store.store_license_img" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<el-form-item label="法人身份证" prop="store_idcard_img">
					<el-upload class="avatar-uploader" :show-file-list="false" :action="host+'/store/upload'"
						:on-success="onSuccessstore_idcard_img" :data="{dir:'store'}" :limit="1">
						<img v-if="store.store_idcard_img" :src="host+store.store_idcard_img" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="门店logo" prop="store_logo">
					<el-upload class="avatar-uploader" :show-file-list="false" :action="host+'/store/upload'"
						:on-success="onSuccessstore_logo" :data="{dir:'store'}" :limit="1">
						<img v-if="store.store_logo" :src="host+store.store_logo" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="门店图片" prop="store_img">
					<el-upload class="avatar-uploader" :show-file-list="false" :action="host+'/store/upload'" :limit="1"
						:on-success="onSuccessstore_img" :data="{dir:'store'}">
						<img v-if="store.store_img" :src="host+store.store_img" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>


			</el-form>
			<div style="width: 100%;display: flex;justify-content: center;padding-top: 30px;">
				<el-button style="width: 200px;" type="primary" @click="resetForm">重置门店</el-button>
				<el-button style="margin-left: 50px;width: 200px;" type="primary" @click="addStore">添加门店</el-button>
			</div>
		</div>
	</el-card>
</template>

<script>
	export default {
		data() {
			var admin_password2 = (rule, value, callback) => {
				if (value != this.store.store_password) {
					return callback(new Error('两次密码不一致'));
				}else{
					callback();
				}
			}
			return {
				store: {
					store_license_img: '',
					store_idcard_img: '',
					store_logo: '',
					store_img: '',
					alipay_login_user: ''
				},
				rules: {
					store_name: [{
						required: true,
						message: '请输入门店名称',
						trigger: 'change'
					}],
					store_img: [{
						required: true,
						message: '请上传门店图片',
						trigger: 'change'
					}],
					store_logo: [{
						required: true,
						message: '请上传门店logo',
						trigger: 'change'
					}],
					store_idcard_img: [{
						required: true,
						message: '请上传法人身份证',
						trigger: 'change'
					}],store_license_img: [{
						required: true,
						message: '请上传营业执照',
						trigger: 'change'
					}],
					store_man: [{
						required: true,
						message: '请输入负责人姓名',
						trigger: 'change'
					}],
					store_tel: [{
						required: true,
						message: '请输入联系电话',
						trigger: 'change'
					}],
					store_tel2: [{
						required: true,
						message: '请输入紧急联系人',
						trigger: 'change'
					}],
					store_address: [{
						required: true,
						message: '请输入门店地址',
						trigger: 'change'
					}],
					store_password: [{
						required: true,
						min: 6,
						message: '请输入5位以上的密码',
						trigger: 'change'
					}],
					alipay_login_user: [{
						required: true,
						message: '请输入提现支付宝账号',
						trigger: 'change'
					}],
					store_password2: [{
						required: true,
						validator: admin_password2,
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {

		},
		methods: {
			resetForm() {
				this.$refs['form'].resetFields();
			},
			addStore() {
				var sub = true;
				var that = this;
				console.log("到这里了");
				this.$refs['form'].validate((valid) => {
					console.log("开始验证了");
					if (valid) {
						that.$axios.post('zuche/admin/addStore', that.store).then(function(res) {
							if (res.data.success) {
								that.$message.success('添加成功');
								that.resetForm();
							} else {
								that.$message.error(res.data.message);
							}
						});
					} else {
						console.log("校验不通过！");
					}
				});
			},

			onSuccesslicense_img(res, file) {
				this.store.store_license_img = res.result;
			},
			onSuccessstore_idcard_img(res, file) {
				this.store.store_idcard_img = res.result;
			},
			onSuccessstore_logo(res, file) {
				this.store.store_logo = res.result;
			},
			onSuccessstore_img(res, file) {
				this.store.store_img = res.result;
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/addStore.vue